<script setup lang="ts">
import { computed } from 'vue';
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import { FeedSummaryGenerationState } from '@/types';

const props = defineProps<{
  state: FeedSummaryGenerationState;
}>();

defineEmits<{
  click: [e: MouseEvent];
}>();

const disabled = computed(
  () => props.state !== 'ready' && props.state !== 'ready-stale',
);

const tooltipText = computed(() => {
  if (props.state === 'no-update' || props.state === 'no-articles') {
    return '記事が更新されていません。';
  }
  if (props.state === 'processing') {
    return '主要トピックを作成中です';
  }
  return undefined;
});
</script>

<template>
  <button
    type="button"
    class="summary c-btn c-btn--auto c-btn--small c-btn--AnewsPrimary"
    :disabled
    :class="{ disabled }"
    @click="$emit('click', $event)"
    v-tooltip="tooltipText"
  >
    <DgrIcon
      name="sparkles-fill"
      size="small"
      :keep-fill="false"
      class="sparkles"
    />
    主要トピック
  </button>
</template>
<style scoped lang="scss">
.summary {
  gap: 4px;
}
</style>
